import {
  FORM_ELEMENT_EMAIL,
  FORM_ELEMENT_FIRST_NAME,
  FORM_ELEMENT_LAST_NAME,
} from 'constants/FormConstants';
import { TABLE_INITIAL_ROWS_NUMBER } from 'constants/TableConstants';
import { TableSettingsType } from 'hooks/useTable';

export const blockedAppUsersTableSettings: TableSettingsType = {
  initialRowsNumber: TABLE_INITIAL_ROWS_NUMBER,
  dataTestId: 'appUsersTable',
  columns: [
    {
      title: 'appUsers.firstName',
      field: FORM_ELEMENT_FIRST_NAME,
    },
    {
      title: 'appUsers.lastName',
      field: FORM_ELEMENT_LAST_NAME,
    },
    {
      title: 'appUsers.email',
      field: FORM_ELEMENT_EMAIL,
    },
  ],
};
